const formatTime = (value) => {
  const clearedValue = value.replace(/[^0-9]+/g, '');
  const hour = clearedValue.substring(0, 2) || '00';
  const minute = clearedValue.substring(2).substring(0, 2) || '00';
  return `${hour.length === 1 ? '0' : ''}${hour}:${minute}${
    minute.length === 1 ? '0' : ''
  }`;
};

export default formatTime;
